/**
 * Preload routes to improve perceived performance
 * Call these functions when user is likely to navigate to a route
 */

// Preload Dashboard (most common route after login)
export const preloadDashboard = () => {
  import('@/pages/Dashboard')
}

// Preload Models page (high-traffic page)
export const preloadModels = () => {
  import('@/pages/Models')
}

// Preload Predictions page (high-traffic page)
export const preloadPredictions = () => {
  import('@/pages/Predictions')
}

// Preload DataSources page
export const preloadDataSources = () => {
  import('@/pages/DataSources')
}

// Preload all critical routes (call after login)
export const preloadCriticalRoutes = () => {
  // Delay preloading to avoid blocking initial render
  requestIdleCallback(() => {
    preloadDashboard()
    preloadModels()
    preloadPredictions()
  }, { timeout: 2000 })
}

// Polyfill for requestIdleCallback
function requestIdleCallback(callback: () => void, options?: { timeout?: number }) {
  if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
    return window.requestIdleCallback(callback, options)
  }
  // Fallback for browsers that don't support requestIdleCallback
  const start = Date.now()
  return setTimeout(() => {
    callback()
  }, Math.max(0, (options?.timeout || 0) - (Date.now() - start)))
}
